import axios from "axios";

const getBaseURL = () =>
  window.location.host.includes("localhost")
    ? process.env.REACT_APP_BASE_URL_LOCAL
    : process.env.REACT_APP_BASE_URL;

const getAdminSettings = async () => {
  try {
    const res = await axios.get(`${getBaseURL()}/adminSettings`);
    const currentData = res.data.filter((obj) => obj.activeInd === "Y");
    const adminSettings = currentData[0];
    return adminSettings;
  } catch (err) {
    console.log(err);
    return "";
  }
};

export { getAdminSettings, getBaseURL };
